import React from "react";
import App from "./App.js";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "bootstrap/dist/css/bootstrap.rtl.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./assets/global.scss";
import "./assets/utils/global-style.scss";
import "./assets/kits/Colors.scss";
import "./assets/kits/Spacing.scss";
import "rc-pagination/assets/index.css";

const root = createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);
